import { render } from "./FbEmptyCell.vue?vue&type=template&id=742f3cb0"
import script from "./FbEmptyCell.vue?vue&type=script&lang=js"
export * from "./FbEmptyCell.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__